var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLooperGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 402,
    viewBox: "0 0 181 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0526316,
    d: "M141.817 14.9651C131.434 1.15249 98.2519 -21.9613 48.5789 -3.91523C-13.5122 18.6423 -37.5264 78.4364 -92.9436 109.44C-133.846 132.324 -243.751 166.673 -306.949 128.717",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.105263,
    d: "M152.057 43.9236C143.176 29.1014 112.591 2.64568 61.3039 15.4006C-2.80506 31.3444 -32.9378 88.3007 -91.2923 113.342C-134.362 131.825 -247.256 154.497 -306.14 110.143",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.157895,
    d: "M159.795 73.2726C152.511 57.6032 124.859 28.0955 72.5199 35.4196C7.09561 44.5748 -28.8257 98.0693 -89.478 116.874C-134.244 130.753 -248.889 141.501 -302.814 91.2347",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.210526,
    d: "M165 102.746C159.394 86.4011 134.978 54.1646 82.16 55.9777C16.1371 58.244 -25.1791 107.691 -87.4648 120.052C-133.436 129.176 -248.577 127.881 -296.952 72.2539",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.263158,
    d: "M167.674 132.08C163.808 115.239 142.895 80.6269 90.1764 76.909C24.2784 72.2616 -21.9801 117.119 -85.2168 122.902C-131.89 127.171 -246.265 113.847 -288.561 53.468",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.315789,
    d: "M167.847 161.014C165.762 143.861 148.582 107.253 96.5409 98.0447C31.4896 86.5345 -19.2043 126.311 -82.699 125.452C-129.563 124.819 -241.918 99.613 -277.671 35.1433",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.368421,
    d: "M165.572 189.284C165.291 172.007 152.032 133.804 101.239 119.206C37.7469 100.959 -16.8271 135.219 -79.8843 127.728C-126.425 122.199 -235.531 85.3873 -264.348 17.5336",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.421053,
    d: "M160.934 216.645C162.461 199.433 153.268 160.052 104.278 140.226C43.0417 115.442 -14.8143 143.809 -76.7431 129.768C-122.451 119.405 -227.111 71.3899 -248.678 0.895655",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.473684,
    d: "M154.04 242.845C157.358 225.887 152.331 185.762 105.683 160.923C47.3721 129.874 -13.1322 152.038 -73.254 131.601C-117.628 116.516 -216.696 57.8247 -230.776 -14.5378",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.526316,
    d: "M145.024 267.664C150.096 251.146 149.291 210.715 105.495 181.136C50.7488 144.162 -11.7407 159.88 -69.397 133.27C-111.952 113.63 -204.341 44.9047 -210.781 -28.5332",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.578947,
    d: "M134.043 290.882C140.814 274.985 144.24 234.691 103.775 200.696C53.1945 158.202 -10.5957 167.302 -65.1546 134.812C-105.423 110.831 -190.123 32.8245 -188.851 -40.8841",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.631579,
    d: "M121.272 312.302C129.668 297.199 137.286 257.484 100.597 219.446C54.7346 171.898 -9.6574 174.28 -60.5212 136.265C-98.0625 108.206 -174.145 21.7733 -165.175 -51.3986",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.684211,
    d: "M106.913 331.748C116.841 317.605 128.57 278.904 96.0571 237.239C55.4163 185.157 -8.87194 180.796 -55.4834 137.672C-89.8861 105.843 -156.517 11.931 -139.947 -59.9025",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.736842,
    d: "M91.1761 349.07C102.528 336.043 118.238 298.78 90.2586 253.945C55.2845 197.9 -8.19568 186.843 -50.0441 139.083C-80.9313 103.832 -137.38 3.46964 -113.393 -66.2383",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.789474,
    d: "M74.2959 364.128C86.9476 352.359 106.466 316.942 83.3268 269.428C54.4025 210.035 -7.57413 192.402 -44.201 140.529C-71.2343 102.243 -116.883 -3.46964 -85.7412 -70.2884",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.842105,
    d: "M56.5134 376.819C70.326 366.436 93.4398 333.254 75.3937 283.581C52.8362 221.49 -6.95786 197.476 -37.9619 142.058C-60.8451 101.156 -95.1942 -8.74938 -57.238 -71.9468",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.894737,
    d: "M38.0764 387.057C52.8986 378.176 79.3543 347.591 66.5994 296.304C50.6556 232.195 -6.30066 202.062 -31.3421 143.708C-49.8246 100.638 -72.4973 -12.2563 -28.1431 -71.14",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.947368,
    d: "M19.2528 394.795C34.9222 387.511 64.4299 359.859 57.1058 307.52C47.9506 242.096 -5.54395 206.174 -24.3485 145.522C-38.2277 100.756 -48.9755 -13.8895 1.29068 -67.8144",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.302814 400C16.6477 394.394 48.8842 369.978 47.0712 317.16C44.8048 251.137 -4.64187 209.821 -17.0035 147.535C-26.1274 101.564 -24.8326 -13.5772 30.7949 -61.9524",
    stroke: "#7A80F4",
    strokeWidth: 2.58067
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooperGroup);
export default __webpack_public_path__ + "static/media/looper_group.8147289fa05046dcb359423009f802b5.svg";
export { ForwardRef as ReactComponent };